import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { BeniImmobiliAdapter } from '../components/fascicolo/beni-immobili-update/beni-immobili-adapter';
import { BenePignoratoImmobile } from '../models/immobili/bene-pignorato-immobile';
import { Comune } from '../models/tipologiche/comune';
import { Provincia } from '../models/tipologiche/provincia';
import { StatoEntita } from '../models/tipologiche/stato-entita';
import { TipoDirittoReale } from '../models/tipologiche/tipo-diritto-reale';
import { FormValidationService } from '../services/form-validation.service';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;

export abstract class BeniImmobiliForm extends BaseForm {
  provinceOptions: Provincia[] = [];
  comuniOptions: Comune[] = [];
  formBeneImmobile: BenePignoratoImmobile;
  beniImmobiliForm: FormGroup;
  tipoDirittoRealeOptions: TipoDirittoReale[] = [];
  tipoCatastoOptions: StatoEntita[] = [];
  tipoDenunciaOptions: StatoEntita[] = [];

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
                super();
  }

  populateSelect() {
    if (this.provinceOptions.length === 0) {
      this.helpers.getProvince().subscribe(response => this.provinceOptions = response);
    }

    if (this.tipoCatastoOptions.length === 0) {
      this.helpers.getTipiCatasto().subscribe(response => this.tipoCatastoOptions = response);
    }

    if (this.tipoDirittoRealeOptions.length === 0) {
        this.helpers.getTipiDirittoReale().subscribe(response => this.tipoDirittoRealeOptions = response);
      }

   if (this.tipoDenunciaOptions.length === 0) {
      this.helpers.getTipiDenuncia().subscribe(response => this.tipoDenunciaOptions = response);
    }

  }

  changeProvincia(idProvincia: string) {
    this.helpers.getCittaByProvincia(idProvincia).subscribe(response => this.comuniOptions = response);
  }

  createForm() {
    let beneImmobile = this.getBeneImmobile();
    this.formBeneImmobile = new BeniImmobiliAdapter(beneImmobile).beneImmobile;
    if (this.formBeneImmobile.ubicazione && this.formBeneImmobile.ubicazione.provincia && this.formBeneImmobile.ubicazione.provincia.id !== '-1') {
      this.changeProvincia(this.formBeneImmobile.ubicazione.provincia.id);
    }

    this.beniImmobiliForm = this.campiForm.group({
      tipoCatasto: [this.formBeneImmobile.tipoCatasto, Validators.required],
      valoreBene: [this.formBeneImmobile.valore, Validators.required],
      nudaProprieta: [this.formBeneImmobile.nudaProprieta],
      ipoteca: [this.formBeneImmobile.ipoteca],
      valoreIpoteca: [this.formBeneImmobile.valoreIpoteca],
      descrizioneBene: [this.formBeneImmobile.descrizione, Validators.required],
      viaUbicazione: [this.formBeneImmobile.ubicazione.via],
      civicoUbicazione: [this.formBeneImmobile.ubicazione.civico],
      capUbicazione: [this.formBeneImmobile.ubicazione.cap, Validators.compose([this.formValidationService.cap])],
      cittaUbicazione: [this.formBeneImmobile.ubicazione.localita],
      provinciaUbicazione: [this.formBeneImmobile.ubicazione.provincia],
      nazioneUbicazione: [this.formBeneImmobile.ubicazione.nazione],
      sezione: [this.formBeneImmobile.datiCatastaliBase.sezione],
      foglio: [this.formBeneImmobile.datiCatastaliBase.foglio],
      particella: [this.formBeneImmobile.datiCatastaliBase.particella],
      subparticella: [this.formBeneImmobile.datiCatastaliBase.subParticella],
      subalterno: [this.formBeneImmobile.datiCatastaliBase.subalterno],
      subalterno2: [this.formBeneImmobile.datiCatastaliBase.subalterno2],
      graffato: [this.formBeneImmobile.datiCatastaliBase.graffato],
      edificio: [this.formBeneImmobile.datiCatastaliUrbanoExtra.edificio],
      pianoFabbricato: [this.formBeneImmobile.datiCatastaliUrbanoExtra.piano],
      internoFabbricato: [this.formBeneImmobile.datiCatastaliUrbanoExtra.interno],
      scalaFabbricato: [this.formBeneImmobile.datiCatastaliUrbanoExtra.scala],
      superficieTerreno: [this.formBeneImmobile.datiCatastaliTerreniExtra.superficie],
      unitaMisuraTerreno: [this.formBeneImmobile.datiCatastaliTerreniExtra.unitaMisura],
      tipologiaDenuncia: [this.formBeneImmobile.datiDenuncia.tipoDenuncia],
      numeroDenuncia: [this.formBeneImmobile.datiDenuncia.numero, Validators.compose([this.formValidationService.numeri])],
      annoDenuncia: [this.formBeneImmobile.datiDenuncia.anno, Validators.compose([this.formValidationService.anno])],
      dataDenuncia: [this.formBeneImmobile.datiDenuncia.dataDenuncia],
      vendita: [this.formBeneImmobile.istanzaVendita.vendita],
      dataIstanzaVendita: [this.formBeneImmobile.istanzaVendita.dataIstanza],
      acquirenteIstanzaVendita: [this.formBeneImmobile.istanzaVendita.acquirente],
      ricavatoIstanzaVendita: [this.formBeneImmobile.istanzaVendita.ricavato],
      assegnato: [this.formBeneImmobile.istanzaAssegnazione.assegnato],
      dataIstanzaAssegnazione: [this.formBeneImmobile.istanzaAssegnazione.dataIstanza],
      note: [this.formBeneImmobile.note],
      classe: [this.formBeneImmobile.datiCatastaliBase.classe],
      quota: [this.formBeneImmobile.datiCatastaliBase.quota],
      tipoDirittoReale: [this.formBeneImmobile.datiCatastaliBase.tipoDirittoReale],
      redditoAgrario: [this.formBeneImmobile.datiCatastaliTerreniExtra.redditoAgrario],
      redditoDominicale: [this.formBeneImmobile.datiCatastaliTerreniExtra.redditoDominicale],
      qualita: [this.formBeneImmobile.datiCatastaliTerreniExtra.qualita],
      categoria: [this.formBeneImmobile.datiCatastaliUrbanoExtra.categoria],
      consistenza: [this.formBeneImmobile.datiCatastaliUrbanoExtra.consistenza],
      rendita: [this.formBeneImmobile.datiCatastaliUrbanoExtra.rendita],
      unitaMisura: [this.formBeneImmobile.datiCatastaliUrbanoExtra.unitaMisura],
      zonaCensuaria: [this.formBeneImmobile.datiCatastaliUrbanoExtra.zonaCensuaria],
    });
  }

  update() {
    this.getRequest(this.formBeneImmobile);
  }

  changedIpoteca(newIpoteca: boolean) {
      this.formBeneImmobile.ipoteca = newIpoteca;
      if (!newIpoteca) {
        this.formBeneImmobile.valoreIpoteca = undefined;
      }
    }


  changedVendita(newVendita: boolean) {
      this.formBeneImmobile.istanzaVendita.vendita = newVendita;
      if (!newVendita) {
        this.formBeneImmobile.istanzaVendita.acquirente = undefined;
        this.formBeneImmobile.istanzaVendita.dataIstanza = undefined;
        this.formBeneImmobile.istanzaVendita.ricavato = undefined;
      }
    }

  changedAssegnazione(newAssegnazione: boolean) {
      this.formBeneImmobile.istanzaAssegnazione.assegnato = newAssegnazione;
      if (!newAssegnazione) {
        this.formBeneImmobile.istanzaAssegnazione.dataIstanza = undefined;
      }
    }

  abstract getBeneImmobile(): BenePignoratoImmobile;
  abstract getRequest(request: BenePignoratoImmobile);
}
